import { createAsyncThunk } from '@reduxjs/toolkit'
import { getInfoRestaurant } from '~/utils'
import request from '~/apis/request'
import { MERCHANT_TYPE } from '~/constants'

export const fetchServingOrder = createAsyncThunk(
  'orderHistory/requestOrderHistory',
  async (controller, { rejectWithValue }) => {
    try {
      const { restaurantId, tableId, merchant_type } = getInfoRestaurant()
      const isTypeSouvenir = merchant_type === MERCHANT_TYPE.SOUVENIR

      const URL = isTypeSouvenir
        ? `/restaurants/${restaurantId}/requests`
        : `/restaurants/${restaurantId}/tables/${tableId}/requests`

      const response = await request().get(URL, {
        signal: controller?.signal,
      })
      return response.data
    } catch (error) {
      if (!error.response) throw error
      const { status, data } = error.response
      return rejectWithValue({ status, data })
    }
  },
)
